import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'expo-bag-note',
    standalone: true,
    imports: [TranslocoPipe, NgbAccordionModule, ReactiveFormsModule],
    templateUrl: './bag-note.component.html',
    styleUrls: ['./bag-note.component.css'],
})
export class ExpoBagNoteComponent implements OnInit {
    
    @Output() note = new EventEmitter<any>();
    @Output() notePanelOpen = new EventEmitter<boolean>();

    expoNoteForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder
    ) {
        this.expoNoteForm = this.formBuilder.group({
            notes: ['']
        });
    }

    ngOnInit(): void {
    }

    onPanelShow($event) {
        this.notePanelOpen.emit(true);
    }

    onSubmit(){
        //eitehr check note changes elsewhere and pass to parent component with output or assigning to variable 
        //this.note.emit();
    }



}
